import { IDeleteEntregaPesquisaSatisfacaoUseCase } from "../../../presentation/useCases/delete/delete_entrega_pesquisa_satisfacao_use_case";
import { IEntregaObrasRepository } from "../../repositories/entrega_obras_repositories";

/**
 * DeleteEntregaPesquisaSatisfacaoUseCase
 */

export class DeleteEntregaPesquisaSatisfacaoUseCase implements IDeleteEntregaPesquisaSatisfacaoUseCase {
  constructor(private readonly repository: IEntregaObrasRepository) { }

  async execute(idEntregaPesquisa: number): Promise<void> {
    await this.repository.deleteEntregaPesquisaSatisfacao(idEntregaPesquisa);
  }
}
